// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MarkPreferences {\n  padding: 20px 0;\n  height: 556px;\n  overflow-y: auto;\n}\n.MarkPreferences::-webkit-scrollbar {\n  display: none;\n}\n.MarkPreferences .language {\n  display: flex;\n  width: 50%;\n}\n.MarkPreferences .language .languageLabel {\n  display: flex;\n  flex-basis: 0;\n  flex-grow: 1.5;\n  justify-content: flex-end;\n  padding-right: 20px;\n}\n.MarkPreferences .language .language-select {\n  flex-grow: 1.5;\n  flex-basis: 0;\n}\n", ""]);
// Exports
module.exports = exports;
